module.exports = __webpack_public_path__ + "img/stick_nature_vallees_gorges.1d02a20f.svg";